import Echo from "laravel-echo";
import Pusher from "pusher-js";

const token = sessionStorage.getItem("token-session");
const baseURL = "api-agente.tallk.me";

const echo = () =>
  new Echo({
    broadcaster: "pusher",
    key: "50bd79047c76eea830a5",
    cluster: "sa1",
    wsHost: baseURL,
    wssPort: 443,
    forceTLS: true,
    encrypted: false,
    enabledTransports: ["ws", "wss"],
    channelAuthorization: {
      transport: "ajax",
      endpoint: `https://${baseURL}/api/pusher/auth`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

export { Pusher, echo };
